import { TableBodyCell, Button, Typography, pxToRem, theme } from '@pocketlaw/tetris';
import styled from 'styled-components';
export const StyledTableCell = styled(TableBodyCell) `
  max-width: ${pxToRem(500)};
`;
export const Container = styled.div `
  display: flex;
  flex-direction: row;
  align-items: center;
`;
export const StyledButton = styled(Button) `
  flex: 1;
  justify-content: flex-start;
  margin: ${theme.spacing.sm} 0;
  padding: ${pxToRem(5)} 0;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`;
export const StyledCellText = styled(Typography) `
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`;
